import { useHistory } from "react-router";

import { Button, Text } from "@alpacahq/ui/old";

import { Path } from "~/v2/path";
import { Layout } from "../Layout";

const HighYieldCashEnrollmentCompletedPage = () => {
  const history = useHistory();

  const onHomeClicked = () => {
    history.push(Path.ROUTE_DASHBOARD);
  };

  const onDepositClicked = () => {
    history.push(Path.ROUTE_FUNDING_DEPOSIT);
  };

  return (
    <Layout title="Thank you!" showFAQ>
      <div>
        <Text>
          Your enrollment is in progress. The status will be visible on your
          dashboard.
        </Text>
        <Text>
          Your first interest accrual will post to your account end of month.{" "}
        </Text>
      </div>
      <div className="flex items-center justify-end gap-4">
        <Button
          variant="alternate"
          className="border-yellow-400"
          onClick={onHomeClicked}
        >
          Done, Take Me Home
        </Button>
        <Button onClick={onDepositClicked}>Deposit Now</Button>
      </div>
    </Layout>
  );
};

export default HighYieldCashEnrollmentCompletedPage;
